export default "__VITE_ASSET__004d6134__"